import { type CoreContractPreview } from '@flecto/types'

import { useDocumentState } from '../../booking-documents/hooks/useDocumentState'

export const useContractTitle = () => {
  const { documentPreview } = useDocumentState()

  const getContractTitle = (): string => {
    if (!documentPreview) {
      return ''
    }

    const bookingSettings = documentPreview?.booking_settings
    const customTitle = bookingSettings?.contract_title
    const includeId = bookingSettings?.documents_contract_include_id_on_title
    const contractId = (documentPreview as CoreContractPreview)
      ?.booking_settings?.document_next_contract_id
    const includeIdString = includeId ? `#${contractId}` : ''

    let contractTitle = ''

    if (customTitle) {
      contractTitle = `${customTitle}${includeIdString ? ' ' + includeIdString : ''}`
    }

    if (!customTitle) {
      contractTitle = includeIdString
    }

    return contractTitle.trim()
  }

  return { getContractTitle }
}
